import {
  Button,
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Card,
  Badge,
  FormGroup,
} from "react-bootstrap";
import React, { useEffect, useState, useRef } from "react";
import storage from "../../../helpers/storage";
import PhotoGalleryImg from "../../../assets/images/photo-gallery-img1.png";
import { TodaysInspectionModule } from "./TodaysInspectionModule";
import { UpcomingInspectionModule } from "./UpcomingInspectionModule";
import Modal from "react-bootstrap/Modal";
import { Scrollbars } from "react-custom-scrollbars";
import { PreviousInspectionModule } from "./PreviousInspectionModule";

export const Dashboard = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleModalClose = () => setShow(false);
  const userInformation: any = storage.getData("user-info");

  const userId = userInformation.id;
  return (
    <section className="profile-main pt-4 inspector-bg">
      <Container className="">
        <Row>
          <Col md={12} lg={12} className="inspector-tab-p-0">
            <Card className="border-0 mb-3">
              <TodaysInspectionModule userId={userId} />
              <UpcomingInspectionModule userId={userId} />
              <PreviousInspectionModule userId={userId} />
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
